/**************************************************
 * Nombre:       Tarjeta_Foto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import foto from '../../Recursos/tmp_foto.png'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Foto = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                width: '100%',
                height: sCell ? 180 : 230,
                backgroundImage: `linear-gradient(0deg, #000 0%, rgba(255, 255, 255, 0.00) 66.25%), url(${foto})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                py: 1,
                px: 2

            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Zoom>
                    <img src={foto} width={'100%'} height={'auto'} style={{opacity: 0}}/>
                </Zoom>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: -2}}>
                <Typography sx={{fontWeight: 400, color: '#fff'}}>
                    {item.nombre}
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Foto